import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class BillOfMaterialService {
    constructor(http) {
        this.http = http;
        this.editor = PLATFORM.moduleName('pages/quote-setup/bill-of-material/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`bill-of-material/filter/${loadOptions}`);
        return await response.json();
    }

    async filterChildren(partId, loadOptions) {
        const response = await this.http.fetch(`bill-of-material/${partId}/children/filter/${loadOptions}`);
        return await response.json();
    }

    async getChildren(partId) {
        const response = await this.http.fetch(`bill-of-material/parents/${partId}/children`);
        return await response.json();
    }

    async create(id, childPart) {
        await this.http.fetch(`bill-of-material/${id}`, { method: 'POST', body: json(childPart) });
    }

    async update(id, childPart) {
        await this.http.fetch(`bill-of-material/${id}/${childPart.id}`, { method: 'PUT', body: json(childPart) });
    }

    async delete(id, childId) {
        await this.http.fetch(`bill-of-material/${id}/${childId}`, { method: 'DELETE' });
    }

    async getById(id, childId) {
        const response = await this.http.fetch(`bill-of-material/${id}/${childId}`);
        return await response.json();
    }
}